import { trimUtmValue, UTM_KEYS } from '../utils/utmUtils';

/**
 * Normalise a contact form payload before sending it to the backend.
 *
 * CompanyPicker emits an empty string `""` when the user clears the company
 * selection ("No company").  The backend stores `account_id` as an optional
 * foreign key — an empty string is a garbage value that breaks account joins.
 *
 * This utility converts `account_id: ""` (or whitespace-only) to `null` so the
 * backend receives a clean null, which the ContactUpdate model validator and
 * the $unset handler turn into a proper field removal.  This mirrors the
 * existing `owner_id: newOwnerId || null` pattern used by the owner-assign flow.
 *
 * UTM acquisition fields are normalised the same way: trimUtmValue trims
 * whitespace and converts empty strings to null so the backend $unsets cleared
 * fields instead of storing "".  This keeps the editForm (header Save) path
 * consistent with the LeadPipelineCard drawer path (saveUtms), which already
 * applies trimUtmValue.
 *
 * Apply at the save boundary (handleSave), not inside individual field
 * components, so the input contract stays simple.
 *
 * @param {Object} form - the form state object (e.g. editForm or form)
 * @returns {Object} a shallow copy with account_id and UTM fields normalised
 */
export function normalizeContactPayload(form) {
    const payload = { ...form };
    if ('account_id' in payload && !payload.account_id) {
        payload.account_id = null;
    }
    UTM_KEYS.forEach(k => {
        if (k in payload) payload[k] = trimUtmValue(payload[k]);
    });
    return payload;
}
